var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4327 3.14111C12.7398 3.14111 11.2932 4.34781 10.4985 5.17973C9.70371 4.34781 8.26036 3.14111 6.56825 3.14111C3.65167 3.14111 1.61548 5.17407 1.61548 8.08419C1.61548 11.2907 4.14436 13.3633 6.59086 15.368C7.74586 16.3154 8.94125 17.2943 9.85798 18.3798C10.0122 18.5616 10.2384 18.6666 10.4759 18.6666H10.5227C10.761 18.6666 10.9863 18.5608 11.1398 18.3798C12.0581 17.2943 13.2527 16.3146 14.4085 15.368C16.8542 13.3641 19.3847 11.2915 19.3847 8.08419C19.3847 5.17407 17.3485 3.14111 14.4327 3.14111Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.3b3a3951.svg";
export { ForwardRef as ReactComponent };